import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottosListItemComponent } from './lottos-list-item.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule, IfItemEnabled } from '@fgb/portal-component-library/src/lib/directives';
import { RouterModule } from '@angular/router';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CarouselModule } from 'ngx-owl-carousel-o';

@NgModule({
  declarations: [LottosListItemComponent],
  imports: [
    CommonModule,
    LoyaltyIconModule,
    CountdownModule,
    PipesModule,
    DirectivesModule,
    IfItemEnabled,
    RouterModule,
    CarouselModule,
    FGBSharedModule
  ],
  exports: [LottosListItemComponent],
})
export class LottosListItemModule {}
